export default  [
  '/WxRobot/GetWxLoginResult',
  '/WxRobot/GetPorts',
]
